module.exports.convertSecondsToTime = seconds => {
  const minutes = String(Math.floor(seconds / 60)).padStart(2, '0')
  const remainingSeconds = String(seconds % 60).padStart(2, '0')

  return `${minutes}:${remainingSeconds}`
}

module.exports.formatMinutesToHours = minutes => {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  if (hours === 0) return `${mins} минут`
  if (mins === 0) return `${hours} ч`

  return `${hours} ч ${mins} минут`
}
